import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../context/ThemeContext';

const ToggleButton = styled.button`
  position: relative;
  width: 60px;
  height: 30px;
  border-radius: 15px;
  background: ${props => props.theme.colors.accentGradient};
  cursor: pointer;
  border: none;
  outline: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(94, 23, 235, 0.3);
`;

const ToggleThumb = styled.span`
  position: absolute;
  left: ${props => (props.isLight ? '4px' : '32px')};
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
`;

const IconContainer = styled.span`
  color: white;
  font-size: 14px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 100%;
`;

// Composant pour cacher visuellement du texte pour les lecteurs d'écran
const VisuallyHidden = styled.span`
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
`;

const MoonIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
        <path d="M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"></path>
    </svg>
);

const SunIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
        <path d="M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"></path>
    </svg>
);

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();
    const isLight = theme.name === 'light';

    return (
        <ToggleButton
            onClick={toggleTheme}
            theme={theme}
            aria-label={isLight ? "Activer le mode sombre" : "Activer le mode clair"}
            title={isLight ? "Activer le mode sombre" : "Activer le mode clair"}
        >
            <IconContainer style={{ marginRight: '4px' }} aria-hidden="true">
                <SunIcon />
            </IconContainer>
            <ToggleThumb isLight={isLight} aria-hidden="true">
                {isLight ? <SunIcon /> : <MoonIcon />}
            </ToggleThumb>
            <IconContainer style={{ marginLeft: '4px' }} aria-hidden="true">
                <MoonIcon />
            </IconContainer>
            <VisuallyHidden>
                {isLight ? "Activer le mode sombre" : "Activer le mode clair"}
            </VisuallyHidden>
        </ToggleButton>
    );
};

export default ThemeToggle;